import actions from "./actions";

const initState = {
  drivers: [],
  driversTurnOver: [],
  loading: false,
};

export default function driversReducer(state = initState, { type, ...action }) {
  switch (type) {
    case actions.GET_DRIVERS_SUCCESS:
      return {
        ...state,
        drivers: action.drivers,
      };

    case actions.GET_ORDERS_INFO_REQUEST:
      return {
        ...state,
        loading: true,
      };

    case actions.GET_ORDERS_INFO_SUCCESS:
      return {
        ...state,
        driversTurnOver: action.ordersInfo,
        loading: false,
      };

    default:
      return state;
  }
}
